import { http, HttpResponse } from 'msw';
import { oracleMocks } from '../mocks';

export const allQuickHandler = http.get('*/oracle/allQuick*', () =>
  HttpResponse.json(oracleMocks.allQuick)
);

export const settingsHandler = http.get('*/oracle/settings?*', () =>
  HttpResponse.json(oracleMocks.settings)
);
